import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function ScoreModal({ show, handleClose, score, highScore }) {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Game Over</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <h4 className="mb-3">Time's Up!</h4>
        <h5 className="mb-2">Score: <strong className="text-primary">{score}</strong></h5>
        <h6>High Score: {score > highScore ? score : highScore}</h6>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant="primary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
